export const DIRECTION = 'DIRECTION';
export const POSITION = 'POSITION';
export const STACK = 'STACK';
export const SALARY = 'SALARY';
export const CURRENCY = 'CURRENCY';
export const CITY = 'CITY';
export const ONSITE = 'ONSITE';
export const VACANCIES = 'VACANCIES';
export const EXPERIENCES = 'EXPERIENCES';
export const SEARCHED = 'SEARCHED';
export const TOTAL = 'TOTAL';